// eslint-disable-next-line no-restricted-imports
import { Amount } from '@george-labs.com/design-system';

import { localizedAmountComponentService } from './LocalizedAmountComponentService';

export const LocalizedAmount = localizedAmountComponentService(Amount);
